export const CAMPAIGN_ACTIVITY_FILTERS = {
  all: 'all',
  sends: 'sends',
  statusChanges: 'statusChanges',
  edits: 'edits',
  failures: 'failures',
  replies: 'replies',
  unanswered: 'unanswered',
} as const

export type CampaignActivityFilter =
  (typeof CAMPAIGN_ACTIVITY_FILTERS)[keyof typeof CAMPAIGN_ACTIVITY_FILTERS]

export const CAMPAIGN_ACTIVITY_FILTER_ORDER: readonly CampaignActivityFilter[] =
  [
    CAMPAIGN_ACTIVITY_FILTERS.all,
    CAMPAIGN_ACTIVITY_FILTERS.sends,
    CAMPAIGN_ACTIVITY_FILTERS.statusChanges,
    CAMPAIGN_ACTIVITY_FILTERS.edits,
    CAMPAIGN_ACTIVITY_FILTERS.failures,
    CAMPAIGN_ACTIVITY_FILTERS.replies,
    CAMPAIGN_ACTIVITY_FILTERS.unanswered,
  ]

/**
 * Only "unanswered" is a queue — a failure is a fact about the past, but an
 * unanswered reply is somebody still waiting, so it keeps the alert ink.
 */
export const CAMPAIGN_ACTIVITY_ALERT_FILTERS: readonly CampaignActivityFilter[] =
  [CAMPAIGN_ACTIVITY_FILTERS.unanswered]

export function campaignActivityFilterLabelKey(
  filter: CampaignActivityFilter,
): string {
  return `campaigns.activity.filters.${filter}`
}
